module.exports = __webpack_public_path__ + "de79ab97983aed31ccd51a4aa043df54.svg";